module.exports = __webpack_public_path__ + "img/VirtualMachins.217b5d7 1.5076ab4.svg";